import React from 'react'

import Verb from './Verb'
import CopyButton from '~components/CopyButton'

import Server from './Server'
import Path from './Path'

import { style, copy, wrapper, inner } from './UrlBar.module.scss'

const UrlBar = ({ 
  endpoint 
}) => (
  <div className={ style }>
    <Verb value={ endpoint.verb } />
    <div className={ wrapper }>
      <div className={ inner }>
        <Server value={ endpoint.server.url } />
        <Path value={ endpoint.path } />
      </div>
    </div>
    <div className={ copy }>
      <CopyButton text={ endpoint.url } />
    </div>
  </div>
)

export default UrlBar
